import { Reducer } from "redux";

import { ISectionLogger } from "@multiweb/logging";
import { bridge } from "@multiweb/reactCore/bridge";
import { SagaWithReturnType } from "@multiweb/types/react";
import { ReducerInfo } from "./types";

const { getDIContainer } = bridge;

/** Identifikátory Redux položek pro registraci do DIContainer */
export enum ReduxModuleName {
    reducerInfoArray = "reducerInfoArray",
    sagaArray = "sagaArray",
}

/** Třída umožňující zapojit více custom reducerů a ság. */
export class ReduxRegistrator {
    private static reducerInfoArray: ReducerInfo[] = [];
    private static sagaArray: SagaWithReturnType[] = [];

    private static _logger: ISectionLogger | undefined;

    /** Inicializační funkce. Musí být zavolána před voláním ostatních funkcí z {@link ReduxRegistrator}. */
    public static init(logger: ISectionLogger): void {
        ReduxRegistrator._logger = logger;
    }

    /** Zapojí další custom reducer */
    public static addReducer(name: string, reducer: Reducer): void {
        if (this.reducerInfoArray.map((reducerInfo) => reducerInfo.name).includes(name)) {
            ReduxRegistrator._logger!.warn("Custom reducer with the name %s was already registered! The original one will be overwritten.", name);
            this.reducerInfoArray = this.reducerInfoArray.filter((reducerInfo) => reducerInfo.name !== name);
        }
        this.reducerInfoArray.push({ name, reducer });
        getDIContainer().registerFactory(ReduxModuleName.reducerInfoArray, () => this.reducerInfoArray);
    }

    /** Zapojí další custom ságu */
    public static addSaga(saga: SagaWithReturnType): void {
        this.sagaArray.push(saga);
        getDIContainer().registerFactory(ReduxModuleName.sagaArray, () => this.sagaArray);
    }
}
